export class AuthService {
  constructor() {
    this.sessionTimeout = 8 * 60 * 60 * 1000 // 8 hours in milliseconds
  }

  isAuthenticated() {
    const isAuthenticated = localStorage.getItem('isAdminAuthenticated') === 'true'
    const loginTimestamp = localStorage.getItem('loginTimestamp')
    
    if (!isAuthenticated || !loginTimestamp) {
      return false
    }

    // Check if session has expired
    const currentTime = Date.now()
    const loginTime = parseInt(loginTimestamp)
    
    if (currentTime - loginTime > this.sessionTimeout) {
      this.logout()
      return false
    }

    return true
  }

  logout() {
    localStorage.removeItem('isAdminAuthenticated')
    localStorage.removeItem('loginTimestamp')
  }

  extendSession() {
    if (this.isAuthenticated()) {
      localStorage.setItem('loginTimestamp', Date.now().toString())
    }
  }

  getTimeRemaining() {
    const loginTimestamp = localStorage.getItem('loginTimestamp')
    if (!loginTimestamp) return 0

    const currentTime = Date.now()
    const loginTime = parseInt(loginTimestamp)
    const elapsed = currentTime - loginTime
    const remaining = this.sessionTimeout - elapsed

    return Math.max(0, remaining)
  }

  formatTimeRemaining(milliseconds) {
    if (!milliseconds) return 'Expired'

    const hours = Math.floor(milliseconds / (1000 * 60 * 60))
    const minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60))

    if (hours > 0) {
      return `${hours}h ${minutes}m`
    } else {
      return `${minutes}m`
    }
  }
}

export default new AuthService()
